<div class="job-order-container">

    <section class="job-order-section">
        <app-section-header
        [title]="'Job Order Details'"
        [subtitle]="'Basic information about the Job Order.'"
      ></app-section-header>

      <div class="card-layout">
        <app-dynamic-form
        [formConfig]="jobOrderConfig.jobOrderFormElements"
        [formGroup]="jobOrderForm"
        [readOnly]="isViewMode"
        (onValueChange)="handleFormValueChange($event)"
        (searchTextCleared)="onSearchTextCleared($event)"
        ></app-dynamic-form>
      </div>
    </section>

    <section class="shipping-bill-section">
        <app-section-header
        [title]="'Shipping Bill'"
        [subtitle]="'Select shipping bills for stuffing.'"
        ></app-section-header>

        <div class="card-layout">

        <div class="table-actions">
            <div class="search-bar" *ngIf="!isViewMode"> 
            <app-autocomplete-dropdown
            id="search-bar"
            class="autocomplete-dropdown"
            [placeholder]="jobOrderConfig.itemSearchConfig?.searchPlaceholder"
            [apiUrl]="jobOrderConfig.itemSearchConfig?.apiUrl"
            [selectFields]="jobOrderConfig.itemSearchConfig?.selectFields"
            [filterByKeys]="jobOrderConfig.itemSearchConfig.filterByKeys"
            [limit]="10"
            [orderBy]="jobOrderConfig.itemSearchConfig.orderBy"
            [bindLabel]="jobOrderConfig.itemSearchConfig.bindLabel"
            [bindValue]="jobOrderConfig.itemSearchConfig.bindValue"
            [displayColumns]="jobOrderConfig.itemSearchConfig.displayColumns"
            [additionalFilters]="cargoFilters"
            [disable]="!(!!selectedCustomerId)"
            [(ngModel)]="searchItemText"
            (suggestionSelected)="onItemSelected($event)"
            >
            </app-autocomplete-dropdown>
            <button type="button" class="add-button secondary_button" [disabled]="disableItemAddButton" (click)="addItem()">
                <app-svg-icon class="image-icon"
                            [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
                <span>Add</span>
            </button>
            </div>
        </div>

        <app-editable-table
        #cargoTableComponent
        [tableMeta]="jobOrderConfig.cargoTableMeta"
        [tableData]="itemList"
        [disableTable]="isViewMode"
        [noDataFoundErrorMsg]="'No shipping bills added.'"
        [showInputFieldsOnTh]="false"
        [allowSelection]="false"
        ></app-editable-table>
      </div>

    </section>

    <section class="container-section">
        <app-section-header
        [title]="'Containers'"
        [subtitle]="'Select containers for stuffing and configure Container Load Plan.'"
      ></app-section-header>

      <div class="card-layout">
        <div class="table-actions">
            <div class="search-bar" *ngIf="!isViewMode"> 
            <app-autocomplete-dropdown
            id="search-bar"
            class="autocomplete-dropdown"
            [placeholder]="jobOrderConfig.containerSearchConfig?.searchPlaceholder"
            [apiUrl]="jobOrderConfig.containerSearchConfig?.apiUrl"
            [selectFields]="jobOrderConfig.containerSearchConfig?.selectFields"
            [filterByKeys]="jobOrderConfig.containerSearchConfig.filterByKeys"
            [limit]="10"
            [orderBy]="jobOrderConfig.containerSearchConfig.orderBy"
            [bindLabel]="jobOrderConfig.containerSearchConfig.bindLabel"
            [bindValue]="jobOrderConfig.containerSearchConfig.bindValue"
            [displayColumns]="jobOrderConfig.containerSearchConfig.displayColumns"
            [additionalFilters]="containerFilters"
            [clientSideSearch]="jobOrderConfig.containerSearchConfig?.clientSideSearch"
            [clientSearchData]="jobOrderConfig.containerSearchConfig?.clientSearchData"
            [(ngModel)]="searchContainerText"
            (suggestionSelected)="onContainerSelected($event)"
            >
            </app-autocomplete-dropdown>
            <button type="button" class="add-button secondary_button" [disabled]="disableContainerAddButton" (click)="addContainer()">
                <app-svg-icon class="image-icon"
                            [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
                <span>Add</span>
            </button>
            </div>
    
            <div class="actions" *ngIf="!isViewMode">
            <button
                type="button"
                class="manage-service-button tertiary_button"
                (click)="configureServices()"
            >
                <app-svg-icon
                class="image-icon"
                [path]="'assets/icons/add_plus_icon.svg'"
                ></app-svg-icon>
                <span>Add Services</span>
            </button>
            </div>
        </div>


        <app-editable-table
        #containerTableComponent
        [tableMeta]="jobOrderConfig.containerTableMeta"
        [tableData]="containerList"
        [disableTable]="isViewMode"
        [noDataFoundErrorMsg]="'No Containers selected.'"
        [allowSelection]="false"
        (rowActionTriggered)="handleContainerInlineAction($event)"
        ></app-editable-table>

        <!-- <app-static-table
        #containerTableComponent
        [tableMeta]="jobOrderConfig.containerTableMeta"
        [(data)]="containerList"
        [showCheckBox]="false"
        [readOnlyMode]="isViewMode"
        [noDataFoundMsg]="'No Containers selected'"
        (rowActionTriggered)="handleContainerInlineAction($event)"
        ></app-static-table> -->
      </div>
    </section>

</div>